import { render, staticRenderFns } from "./ManualMatch.vue?vue&type=template&id=622857c6"
import script from "./ManualMatch.vue?vue&type=script&lang=js"
export * from "./ManualMatch.vue?vue&type=script&lang=js"
import style0 from "./ManualMatch.vue?vue&type=style&index=0&id=622857c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports